import { type MetaFunction } from '@remix-run/node'
import { metaTitleAndDescription } from '#app/helpers/metaTags.helper.ts'

export const meta: MetaFunction = () => {
  return metaTitleAndDescription({
    title: 'Clube do Tennis - Termos de Uso',
    description: 'Conheça os termos de uso do Clube do Tennis',
    content_type: 'website',
  })
}

export default function UsageTermsPage() {
  return (
    <>
      <h1 className="text-center">Termos de Uso</h1>
      <p className="fw-bold">
        Política de Privacidade e Termos e Condições - Clube do Tennis (Baseado
        no Goleiro de Aluguel)
      </p>
      <p>
        AO ACESSAR NOSSA PLATAFORMA, VOCÊ DECLARA ESTAR EM TOTAL CONCORDÂNCIA E
        TER TOTAL CIÊNCIA SOBRE A FORMA COMO UTILIZAREMOS SUAS INFORMAÇÕES E
        SEUS DADOS.
      </p>
      <p>
        Reconhecemos o valor de suas informações e tomamos todas as medidas
        cabíveis para protegê-las enquanto estiverem sob nossa responsabilidade.
        Nosso compromisso é manter as informações coletadas de forma sigilosa e
        utilizá-las sempre no interesse dos usuários do Clube do Tennis ("Clube
        do Tennis" ou "Plataforma").{' '}
      </p>
      <p>
        Nosso objetivo é fazer com que nossos usuários se conectem com outros
        tenistas, pratiquem o esporte, façam novas amizades e tenham uma
        experiência contagiante e competitiva.
      </p>
      <p>
        Esta Política de Privacidade e Termos e Condições de Uso (“Política”)
        tem por objetivo explicar de forma clara e acessível como as suas
        informações e dados (“Você”, “Seu”, “Sua”) serão coletados, usados,
        compartilhados e armazenados por meio do acesso e uso da Plataforma
        Clube do Tennis.
      </p>
      <p className="fw-bold">I – DO SERVIÇO, ACEITE E ALTERAÇÕES DA POLÍTICA</p>
      <p>
        1.1. O serviço prestado pelo Clube do Tennis consiste em conectar
        praticantes de tênis que desejam encontrar parceiros para partidas
        amadoras. Desta forma, o Clube do Tennis apenas atua como plataforma de
        conexão para partidas de tênis (''DESAFIOS''), onde os USUÁRIOS terão
        autonomia de escolha no local, data, horário, custos, acessórios e
        outros itens necessários para a realização do DESAFIO.
      </p>
      <p>
        1.2. A utilização do SERVIÇO implica na integral compreensão, aceitação
        e vinculação automática do USUÁRIO a esta POLÍTICA. Ao realizar o
        cadastro na PLATAFORMA e fazer uso do SERVIÇO oferecido, o USUÁRIO
        concorda em respeitar e seguir todas e quaisquer diretrizes dispostas
        nesta POLÍTICA, documentos incorporados ou mencionados nestes e
        legislação pertinente.
      </p>
      <p>
        1.3. Esta POLÍTICA poderá sofrer alterações periódicas, seja por
        questões legais, estratégicas ou por conveniência do Clube do Tennis. O
        USUÁRIO desde já concorda e reconhece que é de sua única e inteira
        responsabilidade a verificação periódica desta POLÍTICA. O Clube do
        Tennis poderá ainda, por mera liberalidade, informar ao USUÁRIO sobre
        alterações significativas nesta POLÍTICA, através de avisos na
        PLATAFORMA ou por e-mail.
      </p>
      <p>
        1.4.1. Quaisquer alterações nesta POLÍTICA entrarão em vigor
        imediatamente quando da publicação nas PLATAFORMAS. Caso o USUÁRIO não
        concorde com as alterações, deverá solicitar o cancelamento de seu
        cadastro na PLATAFORMA.
      </p>
      <p>
        1.4.2. Não havendo manifestação de cancelamento da conta ou caso o
        USUÁRIO continue utilizando as PLATAFORMAS, entender-se-á que o USUÁRIO
        aceitou tacitamente os novos termos da POLÍTICA e a ela está vinculado.
      </p>

      <p className="fw-bold">II – DO CADASTRO DOS USUÁRIOS</p>
      <p>
        2.1. Para utilizar o SERVIÇO disponibilizado na PLATAFORMA, o USUÁRIO
        deve criar uma conta no SITE e preencher o cadastro prévio com as
        seguintes informações: nome completo, data de nascimento, e-mail, número
        de telefone celular, sexo e endereço.
      </p>
      <p>
        2.2. O Clube do Tennis se reserva ao direito de utilizar todos os meios
        possíveis e lícitos para identificação do USUÁRIO e confirmação da
        veracidade de seus dados cadastrais, tais como, mas sem se limitar,
        confirmação do e-mail válido, envio de mensagens para número do celular
        cadastrado e realização de ligações telefônicas.
      </p>
      <p>
        2.3. Independentemente do quanto previsto acima, o USUÁRIO é
        exclusivamente responsável pela veracidade dos dados fornecidos, bem
        como por manter todos os seus dados cadastrais atualizados. Caso o Clube
        do Tennis tome conhecimento, por meios próprios ou denúncias, da
        falsidade ou inexatidão dos dados fornecidos no cadastro, o USUÁRIO
        poderá ter seu cadastro suspenso, bloqueado ou excluído, a critério do
        Clube do Tennis, sem prejuízo de responder civil e criminalmente por
        suas ações ou omissões.
      </p>
      <p>
        2.4. O USUÁRIO, ao se cadastrar, criará login e senha que serão
        utilizados para acesso a PLATAFORMA. Esta senha é personalíssima e de
        exclusiva responsabilidade do USUÁRIO, que se compromete a informar
        imediatamente o Clube do Tennis caso verifique utilização ou
        conhecimento destas informações por terceiros, sob pena de responder por
        eventuais fraudes ou prejuízos praticados em seu nome.
      </p>
      <p>
        2.4.1. Caso a senha de acesso venha a ser esquecida pelo USUÁRIO, a
        PLATAFORMA permite que este promova a solicitação de recuperação de
        conta mediante a confirmação de dados pessoais. Entretanto, a
        recuperação de acesso não é garantida, estando o Clube do Tennis isento
        de quaisquer responsabilidades em relação a eventuais prejuízos do
        USUÁRIO decorrentes da impossibilidade de recuperação da conta, seja
        pela impossibilidade de identificar sua propriedade ou qualquer outra
        razão.
      </p>
      <p>
        2.5. O USUÁRIO só poderá manter 01 (um) cadastro no aplicativo, sendo
        completamente proibida a cessão, compartilhamento, venda e/ou aluguel de
        cadastro.
      </p>
      <p>
        2.6. Em caso de falecimento do USUÁRIO, o familiar mais próximo deverá
        enviar e-mail para contato@clubedotennis.com.br. Serão exigidos alguns
        dados do interessado e a remoção da conta do USUÁRIO será realizada pela
        equipe técnica.
      </p>

      <p className="fw-bold">
        III – DOS DADOS COLETADOS/TRATADOS PELO CLUBE DO TENNIS
      </p>
      <p>
        Ao acessar nossa Plataforma, são coletadas as seguintes informações de
        Você (“Dados”):
      </p>
      <p>
        <strong>a) As informações fornecidas por Você:</strong> a partir do seu
        endereço de IP, tais como, data e hora de acesso, o navegador que Você
        está usando, as páginas que acessou na nossa Plataforma, Seu nome,
        endereço de e-mail, CPF, RG, data de nascimento, fotos e outros;{' '}
        <strong>
          b) Outras informações obtidas quando Você acessa nossa Plataforma:
        </strong>{' '}
        O Clube do Tennis também utiliza cookies, que são arquivos de internet
        que armazenam temporariamente o que Você está visitando na rede e
        informações que Você já forneceu voluntariamente ao servidor de
        internet. Pela utilização dos cookies, o Clube do Tennis consegue
        lembrar Suas preferências e configurações, entender seus comportamentos
        e interesses, direcionar campanhas de marketing e compartilhamento;{' '}
        <strong>c) Informações Não-Pessoais:</strong>
        Será considerado dado não pessoal aquele que refletir uma informação ou
        um conjunto de informações sobre Você ou sobre os serviços acessados por
        Você, incluindo os resultados obtidos no acesso a estes serviços, desde
        que não permitam a Sua identificação;{' '}
        <strong>d) Informações de Terceiros:</strong> São os dados que podemos
        obter através de fontes públicas, prestadores de serviços ou de nossos
        parceiros, sempre de acordo com a legislação brasileira, por exemplo:
        alunos inscritos em determinada academia, que disputaram determinado
        campeonato, que contratam os serviços de aula de tênis com determinado
        professor. Você pode consultar as Políticas de Privacidade dos terceiros
        com os quais interage nos próprios websites desses. Além disso, o Clube
        do Tennis também poderá obter Suas informações através de um terceiro
        que tenha a sua permissão para compartilhar suas informações conosco.
      </p>

      <p className="fw-bold">IV - DA FINALIDADE DO TRATAMENTO</p>
      <p>
        O Clube do Tennis poderá realizar a coleta, processamento, tratamento,
        utilização e compartilhamento de dados pessoais para as seguintes
        finalidades:
      </p>
      <p className="fw-bold">a) Dados Pessoais fornecidos por Você:</p>
      <ul>
        <li>
          Realizar a Sua identificação e autenticação na nossa Plataforma;
        </li>
        <li>
          Manter Seu cadastro atualizado e contatarmos Você por telefone,
          e-mail, WhatsApp ou outros meios de comunicação;
        </li>
        <li>
          Cumprir com os termos e condições desta Política, bem como oferecer
          nossos produtos e serviços;
        </li>
        <li>
          Atender às Suas solicitações e dúvidas em nossos canais de
          atendimento;
        </li>
        <li>
          Informar Você sobre as novidades, novos produtos, serviços,
          funcionalidades, conteúdos, notícias e demais eventos relevantes do
          Clube do Tennis;
        </li>
        <li>
          Informar Você sobre as novidades, novos produtos, serviços,
          funcionalidades, conteúdos, notícias e demais eventos relevantes de
          nossos parceiros comerciais;
        </li>
        <li>
          Conhecer Você, continuar inovando, aprimorando e desenvolvendo nossos
          produtos e serviços;{' '}
        </li>
      </ul>
      <p className="fw-bold">
        b) Dados Pessoais obtidos quando Você acessa nossa Plataforma:
      </p>
      <ul>
        <li>Recomendar a Você nossos serviços e produtos;</li>
        <li>
          Customizar os conteúdos e a publicidade que mostramos na nossa
          Plataforma;
        </li>
        <li>
          Melhorar cada vez mais a sua experiência de uso na nossa Plataforma;
        </li>
        <li>Definir/estimar Suas interações;</li>
        <li>
          Realização de estatísticas, estudos, pesquisas e levantamentos
          apropriados e necessários para oferecer a Você nossos serviços, sendo
          que, sempre que possível, os seus dados serão anonimizados para essas
          finalidades;
        </li>
        <li>
          Exibir a Você publicidade, nossa e de parceiros, na Plataforma ou em
          sites terceiros;
        </li>
        <li>Reconhecer e acompanhar a sua navegação;</li>
        <li>
          Criar um perfil sobre Você, personalizando a sua experiência em nossos
          serviços;
        </li>
        <li>Monitorar as atividades e as tendências de uso; </li>
      </ul>
      <p className="fw-bold">
        c) Dados Pessoais necessários para prestarmos nossos serviços e
        oferecermos nossos produtos:
      </p>
      <ul>
        <li>
          Confirmação e complementação dos Seus Dados Pessoais, conforme a
          relação estabelecida com Você;
        </li>
        <li>
          Prevenção de fraudes e garantias de segurança durante a execução de
          nossos serviços e oferecimento dos produtos do Clube do Tennis;
        </li>
        <li>Execução dos contratos ou para procedimentos preliminares;</li>
        <li>
          Cumprimento de obrigações legais ou regulatórias, bem como exercício
          de direitos em processos judiciais, administrativos ou arbitrais;
        </li>
      </ul>
      <p className="fw-bold">d) Dados Pessoais obtidos por terceiros:</p>
      <ul>
        <li>Prevenção ou reparação de problemas técnicos ou de segurança;</li>
        <li>
          Prevenção e proteção de nossos direitos e propriedades, inclusive de
          invasões e incidentes de segurança;
        </li>
        <li>
          Oferecimento de suporte técnico e operacional e garantia da
          funcionalidade dos nossos serviços;
        </li>
        <li>Ofertar nossos serviços e produtos;</li>
        <li>
          Cumprimento de obrigações legais ou regulatórias, bem como exercício
          de direitos em processos judiciais, administrativos ou arbitrais
        </li>
      </ul>
      <p>
        Às vezes podemos utilizar Seus dados para outras finalidades que não
        estão descritas nesta Política, como, por exemplo, para lhe fornecer
        informações gerais sobre outros bens, serviços e eventos que são
        ofertados pelo Clube do Tennis, a menos que Você tenha optado por não
        receber tais informações (opt-out), para fins de pesquisa interna e para
        melhorar o conteúdo dos serviços, bem como para o desenvolvimento de
        novos produtos, mediante a obtenção de seu consentimento, quando exigido
        pela LGPD.
      </p>
      <p className="fw-bold">
        V - DOS SERVIÇOS OFERECIDOS E DOS DIREITOS DOS USUÁRIOS
      </p>
      <p>
        5.1. Estão inclusos no SERVIÇO prestado pelo Clube do Tennis, unicamente
        através de sua PLATAFORMA:
      </p>
      <p>
        a) a hospedagem do perfil do TENISTA em seu banco cadastral para
        consulta dos USUÁRIOS em busca de parceiros de jogo na região atendida
        pelo TENISTA; b) a busca por jogos disponíveis de outros USUÁRIOS,
        levando em consideração nível, localização, e demais fatores; c) a
        participação no Ranking CdT; d) o acesso a loja on-line do CLUBE DO
        TENNIS com eventuais ofertas e condições exclusivas para USUÁRIOS; e) a
        contratação do SERVIÇO "MASTERS", que fornece benefícios para o USUÁRIO,
        como desconto na loja, perfil em destaque, e outros; f) suporte via
        PLATAFORMA, e-mail (contato@clubedotennis.com.br) e WhatsApp para
        esclarecimento de dúvidas técnicas sobre o funcionamento da PLATAFORMA e
        questões relativas a serviços aceitos ou já realizados.
      </p>
      <p>
        5.2. O TENISTA não está obrigado a criar ou aceitar as oportunidades de
        DESAFIOS oferecidas por intermédio da PLATAFORMA, não havendo qualquer
        prejuízo ou infração contratual na recusa imotivada das mesmas.
      </p>
      <p>
        5.3. TODAVIA, CASO O TENISTA ACEITE UM DESAFIO E NÃO COMPAREÇA NO LOCAL
        NO DIA E HORA MARCADOS PARA A REALIZAÇÃO DA PARTIDA, ESTÁ CIENTE, E
        DESDE JÁ CONCORDA, QUE ALÉM DE TAL FATO SER INCLUÍDO EM SEU PERFIL NA
        PLATAFORMA, ESTARÁ SUJEITO À PERDA DE PONTOS NO RANKING DA PLATAFORMA E
        SUSPENSÃO DE ACESSO. O NÚMERO DE PONTOS A SER DESCONTADO E O PRAZO DE
        SUSPENSÃO CONSTAM NO ANEXO I DESTA POLÍTICA - REGRAS DO RANKING CDT.
      </p>
      <p>
        5.4. O USUÁRIO reconhece que inexiste qualquer vínculo empregatício ou
        de subordinação entre o Clube do Tennis e os TENISTAS cadastrados na
        PLATAFORMA, motivo pelo qual o Clube do Tennis não se responsabiliza por
        possíveis lesões decorrentes dos jogos, materiais de jogo (raquete,
        bolas, equipamentos e etc.), transporte até o local da partida, dentre
        outras despesas inerentes à prática esportiva, declarando o USUÁRIO
        estar ciente dessas condições.
      </p>
      <p className="fw-bold">VI – DA POLÍTICA DE COOKIES</p>
      <p>
        O Clube do Tennis utiliza cookies que podem ser classificados em cinco
        categorias: essenciais, de funcionalidade, de desempenho, analíticos e
        de publicidade. Esses cookies são utilizados para reconhecer Você,
        melhorar sua experiência e tornar nossas ofertas mais personalizadas e
        relevantes.
      </p>
      <p>
        Cookies essenciais são necessários para que nossa Plataforma funcione
        corretamente e não podem ser desativados. Cookies de funcionalidade
        permitem lembrar Suas preferências e personalizar a experiência de
        navegação. Cookies de desempenho e analíticos nos ajudam a entender como
        Você utiliza nossa Plataforma e a melhorar a sua funcionalidade. Cookies
        de publicidade são usados para exibir anúncios mais relevantes para
        Você.
      </p>
      <p>
        Você pode controlar o uso de cookies através das configurações do seu
        navegador, contudo, ao desativar cookies, algumas funcionalidades da
        nossa Plataforma podem não funcionar corretamente.
      </p>
      <p className="fw-bold">VII - DO CANCELAMENTO DO CADASTRO E DA RESCISÃO</p>
      <p>
        7.1. O USUÁRIO poderá solicitar o cancelamento de seu cadastro nas
        PLATAFORMAS a qualquer momento, sem justificativa, através da opção
        disponível no APP ou por e-mail.
      </p>
      <p>
        7.2. O Clube do Tennis se reserva ao direito de rescindir imediatamente
        o acesso do USUÁRIO às PLATAFORMAS em casos de infração a estes T&C,
        tentativa de fraude, violação de leis ou regulamentos aplicáveis, ou
        outra justa causa.
      </p>
      <p className="fw-bold">VIII – DAS DISPOSIÇÕES GERAIS</p>
      <p>
        8.1. Esta POLÍTICA constitui o acordo integral entre as Partes em
        relação ao objeto tratado e substituem todos os acordos e entendimentos
        anteriores, sejam verbais ou escritos.
      </p>
      <p>
        8.2. Se qualquer disposição desta POLÍTICA for considerada inválida ou
        inaplicável, as demais disposições continuarão em pleno vigor e efeito.
      </p>
      <p>
        8.3. A tolerância do Clube do Tennis em exigir o estrito cumprimento de
        qualquer cláusula ou condição desta POLÍTICA não constituirá novação ou
        renúncia, nem impedirá que tal exigência seja feita a qualquer tempo.
      </p>
      <p>
        8.5. Esta POLÍTICA será regida e interpretada de acordo com as leis
        brasileiras, e quaisquer disputas decorrentes ou relacionadas a esta
        POLÍTICA, serão submetidas ao foro da comarca da sede do Clube do
        Tennis, renunciando as Partes a qualquer outro foro, por mais
        privilegiado que seja ou venha a ser.
      </p>
      <p className="fw-bold">IX – DO SUPORTE TÉCNICO</p>
      <p>
        9.1. O Clube do Tennis disponibiliza suporte técnico para os USUÁRIOS
        através do e-mail contato@clubedotennis.com.br e pelo WhatsApp. O
        suporte técnico tem como objetivo auxiliar o USUÁRIO em dúvidas
        relacionadas ao uso das PLATAFORMAS e ao serviço oferecido, não sendo
        responsável por resolver questões não relacionadas diretamente ao
        funcionamento do APP ou SITE.
      </p>
      <p>Última atualização: 11 de Outubro de 2024, 00:00:00</p>
    </>
  )
}
